const decorationLineTokens = ({ brandSecondary, colorsGrey, colors }) => ({
  colors: {
    default: brandSecondary,
    negative: colors.white,
    primary: colors.informative.default,
    dark: colorsGrey[0],
    train: colors.trainProductColor,
    flight: colors.flightProductColor,
    grey: colorsGrey[5],
  },
  sizes: {
    disk: {
      small: 14,
      base: 16,
      big: 24,
    },
    circleDot: {
      outsideCircle: {
        small: 14,
        base: 16,
        big: 24,
      },
      centralCircle: {
        small: 5,
        base: 7,
        big: 10,
      },
    },
    icon: {
      small: 26,
      base: 28,
      big: 32,
    },
    height: 'calc(100% + 8px)',
    topLineHeight: 'calc(100% + 10px)',
  },
  space: {
    top: 2,
    offset: 2,
  },
});

export default decorationLineTokens;
